import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NodeConfigurationService} from '../../../services/configuration/node-configuration.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {DomSanitizer} from '@angular/platform-browser';
import {CustomValidator} from '../../../services/custom-validator';

@Component({
  selector: 'app-service-configuration-batcher',
  templateUrl: './service-configuration-batcher.component.html',
  styleUrls: ['./service-configuration-batcher.component.css']
})
export class ServiceConfigurationBatcherComponent implements OnInit {

  @Input() modalTitle: string;
  componentForm: FormGroup;
  objInitialState;
  config;
  pleaseWait = false;
  error;
  submitted;

  get formData() { return this.componentForm.controls; }

  constructor(private nodeConfigService: NodeConfigurationService, public bsModalRef: BsModalRef,
              private formBuilder: FormBuilder, private domSanitizer: DomSanitizer) { }

  ngOnInit() {
    this.pleaseWait = true;
    this.submitted = false;

    if (this.objInitialState) {
      this.config = this.objInitialState;
    }
    this.createForm();
    this.loadConfigs();
  }

  createForm() {
    this.componentForm = this.formBuilder.group({
      inboxDirectory: [ '', [ CustomValidator.trimRequired, Validators.maxLength(2000) ]],
      outboxDirectory: [ '', [ CustomValidator.trimRequired, Validators.maxLength(2000) ]]
    });
  }

  loadConfigs() {
    this.error = '';
    this.nodeConfigService.getByNode(this.config.machineId, this.config.hostName, 10)
      .subscribe(result => {
        if (result) {
          this.componentForm.patchValue({
            inboxDirectory:  result.inboxDirectory,
            outboxDirectory:  result.outboxDirectory
          });
          this.pleaseWait = false;

        }
      }, error1 => {
        this.error = error1;
        this.pleaseWait = false;
      });
  }

  onClose() {
    this.bsModalRef.hide();
  }

  onSave() {
    this.error = '';
    this.pleaseWait = true;
    const obj = this.componentForm.getRawValue();
    obj.machineId = this.config.machineId;
    obj.hostName = this.config.hostName;
    this.nodeConfigService.updateBatcher(obj).subscribe(
      () => {
        this.pleaseWait = false;
        this.submitted = true;
        setTimeout(() => {  this.submitted = false; }, 1700);
      }, error1 => {
        this.pleaseWait = false;
        this.error = error1;
      }
    );
  }

}
